import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

import { FaHome } from "react-icons/fa";

import NavLinks from "./NavLinks.jsx";


import Logo from '../../images/logo_complex_ex3.svg'
import instagram from '../../images/social_media/instagram2.svg';
import youtube from '../../images/social_media/youtube.svg';
import mail from '../../images/social_media/mail.svg';
import facebook from '../../images/social_media/facebook.svg';

const NavBar = () => {
    const [open, setOpen] = useState(false);
    // const i18n = {i18n}
    const { t, i18n } = useTranslation();
    
    function changeToKo(){
        i18n.changeLanguage('ko');
    }
    function changeToEn(){
        i18n.changeLanguage('en');
    }

    return (
    <nav className="bg-white">
        {/* Hearder line */}
        <div id="header-line">
            <div className="flex w-full float:right" style={{flexDirection: 'row', justifyContent: 'flex-end'}}>
                <div>
                    <ul style={{marginTop:"5px"}}>
                        <li style={{display:"inline-block", marginRight:"5px"}}>
                            <a href="https://instagram.com/genomebio_expo?igshid=YmMyMTA2M2Y=">
                                <img src={instagram} style={{height:"28px"}}/>
                            </a>
                        </li>
                        <li style={{display:"inline-block", marginRight:"5px"}}>
                            <a href="https://www.youtube.com/channel/UCOAAPLEUAagjSiuD8e0hYhA">
                                <img src={youtube} style={{height:"28px"}}/>
                            </a>
                        </li>
                        <li style={{display:"inline-block", marginRight:"12px"}}>
                            <a href="mailto:genomebioexpo@gmail.com">
                                <img src={mail} style={{height:"28px"}}/>
                            </a>
                        </li>
                        <li style={{display:"inline-block", marginRight:"15px", verticalAlign:"top"}}>
                            <div style={{fontWeight:"bold",color:"#A136B4"}}>
                                <button onClick={changeToKo}>한국어</button>
                                |
                                <button onClick={changeToEn}>English</button>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        {/* Navigator Bar  */}
        <div className="flex z-50 h-20 bg-white text-base font-bold items-center justify-around fixed w-full" style={{borderBottom:"1px solid #DBDEE5",borderTop:"2px solid #DBDEE5",marginTop:"40px"}}>
            <div className="md:flex hidden elements-hide-1300">
                <Link to="/">
                    <img src={Logo} alt="logo" className="cursor-pointer w-80 h-18 p-5" />
                </Link>
            </div>
            <div className="md:hidden">
                <Link to="/">
                    <img src={Logo} alt="logo" className="cursor-pointer w-80 h-18 p-6" />
                </Link>
            </div>
            <div className="p-10 md:hidden flex justify-end">
                {/* <div className="text-sm mx-3 flex md:hidden md:text-base text-500" style={{color:"#A136B4"}}>
                    <button onClick={changeToKo}>한국어</button>
                    |
                    <button onClick={changeToEn}>English</button>
                </div> */}
                <div className="text-3xl mx-3 md:hidden" onClick={() => setOpen(!open)}>
                    <ion-icon className="mt-6" name={`${open ? "close" : "menu"}`}></ion-icon>
                </div>
            </div>
            <ul className="w-6/12 md:w-10/12 md:flex hidden items-center" style={{flexDirection: 'row', justifyContent: 'flex-end', marginRight:"3.5vw"}}>
                <NavLinks />
            </ul>
            {/* <div className="text-base md:flex hidden text-500" style={{color:"#A136B4"}}>
                    <button onClick={changeToKo}>한국어</button>
                    |
                    <button onClick={changeToEn}>English</button>
            </div> */}
            {/* mobile nav */}
            <ul className={`fixed sm:hidden top-28 bg-white w-full h-full bottom-0 py-24 pl-4 duration-500 z-50 ${open ? 'left-0' : 'left-[-100%]'}`}>
                <NavLinks />
            </ul>
        </div>
    </nav>
    );
};

export default NavBar;
